// src/components/about/TeamData.js

export const founders = [
  {
    name: "Rishabh Jain",
    role: "Co-Founder",
    description:
      "Expert in Web & App Development, SaaS, UI/UX, and Brand Design – Crafting Digital Experiences That Stand Out.",
    linkedin: "https://www.linkedin.com/in/rishabh-jain/",
    instagram: "https://www.instagram.com/rishabhjain/",
    image: "/images/founders/rishabh.jpg", // Replace with actual image path
  },
  {
    name: "Vedant Sethi",
    role: "Co-Founder",
    description:
      "Co-Founder @Doggle India | Community Manager @Urban Company | TSM @Hero MotoCorp | NIT Raipur Alum | Expert in Growth & Strategy.",
    linkedin: "https://www.linkedin.com/in/vedant-sethi/",
    instagram: "https://www.instagram.com/vedantsethi/",
    image: "/images/founders/vedant.jpg", // Replace with actual image path
  },
];

export const team = [
  {
    name: "Harshit Dixit",
    role: "Project Manager – The Project Ka Boss",
    description:
      "Skilled Project Manager with 2+ years of experience in efficient project execution, team coordination, and timely delivery.",
    image: "/images/team/harshit.jpg",
  },
  
  {
    name: "Sachin Barupal",
    role: "Fullstack Developer – The Coding Keeda",
    description:
      "Fullstack Developer Intern with a passion for building dynamic web applications, skilled in frontend & backend development.",
    image: "/images/team/sachin.jpg",
  },
  
  {
    name: "Mehul Saraswat",
    role: "MERN Stack Developer – The Code Wale Pandit",
    description:
      "MERN Stack Developer skilled in building scalable web applications using MongoDB, Express, React, and Node.js.",
    image: "/images/team/mehul.jpg",
  },
  {
    name: "Deepak Jain",
    role: "Video Editor – The Design Ka Ustaad",
    description:
      "Creative Video Editor with expertise in storytelling, motion graphics, and seamless editing to bring visuals to life.",
    image: "/images/team/deepak.jpg",
  },
  {
    name: "Rohan Phuke",
    role: "Digital Marketer – The Ad Guru",
    description:
      "Digital Marketer with 3.5 years of experience in crafting viral campaigns and maximizing ROI. Masters the art of audience targeting, ad optimization, and making numbers look irresistible.",
    image: "/images/team/rohan.jpg",
  },
  
];


export const creativeTeam = [
  {
    name: "Pallavi Bhandari Lakshminarayana",
    role: "Sr. UI/UX Designer – The UX Doctor",
    description:
      "UI/UX Designer with 3 years of experience in creating intuitive, aesthetic, and user-friendly digital experiences. Passionate about seamless navigation, clean layouts, and pixel-perfect designs.",
    image: "/images/team/pallavi.jpg", 
  },
  {
    name: "Hridyansh Jain",
    role: "Graphic Designer – The Design Ka Ustaad",
    description:
      "Creative Graphic Designer with 3+ years of experience in branding, UI/UX, and visual storytelling, delivering impactful and innovative designs.",
    image: "/images/team/hridyansh.jpg", 
  },
  {
    name: "Rohan Phuke",
    role: "Digital Marketer – The Ad Guru",
    description:
      "Digital Marketer with 3.6 years of experience in crafting viral campaigns and maximizing ROI. Masters the art of audience targeting, ad optimization, and making numbers look irresistible.",
    image: "/images/team/rohan.jpg",
  },
  {
    name: "Saloni Mehaeshwari",
    role: "UI/UX Designer",
    description:
      "A skilled UI/UX Designer, creating seamless and engaging digital experiences with a perfect blend of functionality and aesthetics.",
    image: "/images/team/saloni.jpg",
  },
  {
    name: "Sonu Barman",
    role: "UI/UX Designer and Graphic Designer",
    description:
      "UI/UX & Graphic Designer with a creative edge, blending user-centric design with stunning visuals for seamless digital experiences.",
    image: "/images/team/sonu.jpg", 
  },
];
